// extracted by mini-css-extract-plugin
export default {"aboutPropertyDetail":"aboutPropertyDetail___wLi1T","datailsBox":"datailsBox___v3AQ5","title":"title___E7GZu","quetionContaner":"quetionContaner___qrFWQ"};